export default __webpack_public_path__ + "static/context-switcher-dcf6363d7932bb835366e0bd322d32c9.webp";